import React, { use, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import allTeams from '../../data/teams';
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré

interface ScoreProps {
    game: any; // Replace `any` with the actual type for `game`
    homeTeam: any; // Replace `any` with the actual type for `homeTeam`
    awayTeam: any; // Replace `any` with the actual type for `awayTeam`
}

interface Team {
    id: number,
    franchiseId: number,
    fullName: string,
    leagueId: number,
    rawTricode: string,
    triCode: string,
    colors : string[],
    conference: string,
    division: string,
  }

  const numberToMonth = (num) => {
    if(num === 13){
      num = 1;
    }
    if(num === 0){
      num = 12;
    }
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    if(num === 13) num = 1;
    if(num === -1) num = 12;
    const index = parseInt(num, 10); // Convert to integer and adjust for 0-based index
    return months[index] || "Invalid month";
  };

  const getDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate(); // Month is 1-based, so no need to add 1
  };



const Score: React.FC<ScoreProps>  = ({ game, homeTeam, awayTeam }) => {
    const [homeTeamColor, setHomeTeamColor] = useState<string[]>([]);
    const [awayTeamColor, setAwayTeamColor] = useState<string[]>([]);
    const [monthName, setMonthName] = useState<string>("");
    const [dayOfWeek, setDayOfWeek] = useState<string>("");
    const [dayNumber, setDayNumber] = useState<string>("");
    const [yearNumber, setYear] = useState<string>("");

    const getTeamColor = (teamId: number, allTeams: Team[]) => {
        const team = allTeams.find((team) => team.id === teamId);
        return team ? team.colors : null; // Return the color if the team is found, otherwise return null
      };

      function parseOffset(offsetStr: string): number {
        const match = offsetStr.match(/([+-])(\d{2}):(\d{2})/);
        if (!match) return 0;
        const sign = match[1] === "+" ? 1 : -1;
        const hours = parseInt(match[2], 10);
        const minutes = parseInt(match[3], 10);
        return sign * (hours * 60 + minutes) * 60 * 1000;
    }

useEffect(() => {

    const safeHomeTeamColor: string[] = getTeamColor(homeTeam.id, allTeams) || ["#FFFFFF"]; // Default to black
    setHomeTeamColor(safeHomeTeamColor);
    const safeAwayTeamColor: string[] = getTeamColor(awayTeam.id, allTeams) || ["#FFFFF"]; // Default to black
    setAwayTeamColor(safeAwayTeamColor);

    if(game && game.startTimeUTC){
        const utcDate = new Date(game.startTimeUTC);
        const offsetMs = parseOffset(game.venueUTCOffset);
        const gameDate = new Date(utcDate.getTime() + offsetMs);
        console.log("gameDate:", gameDate);
        const month = gameDate.getMonth(); // getMonth() is zero-based
        console.log("month:", month);
        const year = gameDate.getFullYear();
        const day = gameDate.getDate();
        setDayNumber(day.toString());
        console.log("day:", day);
        const monthNameLocal = numberToMonth(month);
        setMonthName(monthNameLocal);
        setYear(year.toString()); // Convert year to string
    }


}, [game, homeTeam, awayTeam]);


    return (
    <div className="teamContent">
        <div className="scoreboard">

            <div className="team-score" style={{ background: `linear-gradient(110deg, ${homeTeamColor[0]} 85%, #fff 85%)`}} >
                <Link to={`/team/${homeTeam.abbrev}`}>
                <div className="logowrapper">
                    <div className="box"><img src={homeTeam?.darkLogo} width={80} /></div>
                    <div className="box">
                        <div className="town">{homeTeam?.placeName?.default}</div>
                        <div className="Teamtitle">{homeTeam.commonName?.default}</div>
                    </div>
                </div>
                <div className="score">{game?.homeTeam?.score}</div>
                </Link>    
            </div>
            <div className="team-score" style={{ background: `linear-gradient(110deg, #fff 15%,  ${awayTeamColor[0]} 15%)`}}>
                <Link to={`/team/${awayTeam.abbrev}`}>

                <div className="score">{game?.awayTeam?.score}</div>
                <div className="logowrapper">
                    <div className="box"><img src={awayTeam?.darkLogo} width={80} /></div>
                    <div className="box">
                        <div className="town">{awayTeam?.placeName?.default}</div>
                        <div className="Teamtitle">{awayTeam.commonName?.default}</div>
                    </div>
                </div>              
                </Link>
            </div>
        </div>
      { dayNumber && <div className="date">{monthName} {dayNumber}, {yearNumber} at {game?.venue?.default}</div> }  
    </div> );
}

export default Score;
